import { gql } from "apollo-boost";

export const COVID_GROWTH_FACTOR = gql`
  query GrowthFactorByCountries($countries: [String!]!) {
    covidCaseOwidByCountries(countries: $countries) {
      alias
      displayName
      data {
        date
        infectionRate
      }
    }
  }
`;

export const COVID_CASES_BY_COUNTRY = gql`
  query CovidCaseByCountry($country: String!) {
    covidCaseOwidByCountry(country: $country) {
      latest {
        date
        newCases
        newDeaths
        newRecovered
        newActive
        newTests
        totalCases
        totalCasesPerMillion
        totalDeaths
        totalDeathsPerMillion
        totalTests
        totalTestsPerThousand
        totalRecovered
        totalRecoveredPerMillion
        totalActive
        totalActivePerMillion
        averageNewCases
        averageNewCasesPerMillion
        averageNewDeath
        averageNewDeathPerMillion
        averageNewTests
        averageNewTestsPerThousand
        averageNewRecovered
        averageNewRecoveredPerMillion
        fatalityRate
        fatalityRateChange
        testsUnits
      }
      data {
        date
        totalCases
        newCases
        averageNewCases
        totalDeaths
        newDeaths
        totalTests
        totalRecovered
        totalActive
        infectionRate
        predictedNewDeath
        fatalityRate
      }
    }
  }
`;
